import { render, staticRenderFns } from "./DeliveryRelated_Row.vue?vue&type=template&id=7865e0eb&"
import script from "./DeliveryRelated_Row.vue?vue&type=script&lang=js&"
export * from "./DeliveryRelated_Row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports